var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
// Autobahn (auto.de redesign) — real md3 leaves (no MUI). Same form bindings + the same
// row/inputLabel layout; only the radio group, inputs and buttons are swapped.
import { FormRadioGroup, FormRadio, Button, FormField } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './DataExportPage.styl';
let ExportSection = class ExportSection extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "renderForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onFormSubmit, t, section } = this.props;
                const { form } = section;
                return (React.createElement("div", null,
                    React.createElement(Trans, { i18nKey: 'activationSection.autoScout24Description' },
                        React.createElement("span", null,
                            "text",
                            React.createElement("strong", null, "text"),
                            "text")),
                    React.createElement("form", null,
                        React.createElement("div", { className: styles.row },
                            React.createElement("div", { className: styles.inputLabel }, t('activationSection.customerId')),
                            React.createElement(FormField, { field: form.$('customerId'), t: t, hideLabel: true })),
                        React.createElement("div", { className: styles.row },
                            React.createElement("div", { className: styles.inputLabel }, t('activationSection.username')),
                            React.createElement(FormField, { field: form.$('username'), t: t, hideLabel: true })),
                        React.createElement("div", { className: styles.row },
                            React.createElement("div", { className: styles.inputLabel }, t('activationSection.password')),
                            React.createElement(FormField, { field: form.$('password'), t: t, hideLabel: true }),
                            React.createElement(Button, { variant: 'filled', className: styles.button, onClick: onFormSubmit }, t('activationSection.activateNow'))),
                        React.createElement("div", { className: styles.row },
                            React.createElement(FormRadioGroup, { field: form.$('status') },
                                React.createElement(FormRadio, { disabled: true, value: 'export_active_automatic', className: styles.radioLabelAutomaticExport }, t('activationSection.enableAutomaticExport')),
                                React.createElement(FormRadio, { value: 'export_active_manual' }, t('activationSection.enableManualExport')))))));
            }
        });
        Object.defineProperty(this, "renderActivePlatform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, isAutomatic, isManual, onDeactivatedClick, section } = this.props;
                const { form } = section;
                const manualExportTranslation = (React.createElement(Trans, { i18nKey: 'activationSection.manualExportActivated' },
                    React.createElement("span", null,
                        "text",
                        React.createElement("br", null),
                        "text",
                        React.createElement(Link, { className: styles.link, to: '/my-vehicles/overview' }, "text"),
                        "text")));
                return (React.createElement("div", null,
                    React.createElement("strong", null,
                        t('activationSection.customerId'),
                        " "),
                    React.createElement("span", null, form.$('customerId').value),
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.slimRow },
                            isAutomatic ? t('activationSection.automaticExportActivated') : null,
                            isManual ? manualExportTranslation : null),
                        React.createElement(Button, { variant: 'outlined', className: styles.secondaryButton, onClick: onDeactivatedClick }, t('activationSection.disableExport')))));
            }
        });
    }
    render() {
        const { t, section, isDeactivated } = this.props;
        const { name, title, logo } = section;
        return (React.createElement("div", { className: styles.ExportSection },
            React.createElement("div", { className: styles.frame, key: name },
                React.createElement("h2", { className: styles.title },
                    React.createElement("span", { className: styles.serviceLabel }, title),
                    React.createElement("span", { className: isDeactivated ? styles.notActiveLabel : styles.activeLabel }, isDeactivated ? t('activationSection.notActiveLabel') : t('activationSection.activeLabel'))),
                isDeactivated ? this.renderForm() : this.renderActivePlatform(),
                logo)));
    }
};
ExportSection = __decorate([
    observer
], ExportSection);
export default ExportSection;
